function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.058,
    height: 21.058,
    viewBox: "0 0 21.058 21.058",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Flat 2",
    transform: "translate(-1 -5.05)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19598",
    d: "M36.4 50a.4.4 0 0 0-.4.4v.8c.134 0 .269.01.4.01s.271-.005.4-.01v-.8a.4.4 0 0 0-.4-.4z",
    transform: "translate(-20.826 -29.157)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19600",
    d: "M42.511 49.2a.4.4 0 0 0-.286.5l.208.774c.264-.06.526-.127.783-.207l-.209-.777a.4.4 0 0 0-.496-.29z",
    transform: "translate(-24.522 -28.67)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19609",
    d: "M12.918 20.013a.4.4 0 0 0-.286-.5l-.777-.209a9.901 9.901 0 0 0-.207.783l.774.208a.4.4 0 0 0 .496-.282z",
    transform: "translate(-6.336 -10.894)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19611",
    d: "M12.215 26.4a.4.4 0 0 0-.4-.4h-.8c0 .134-.01.269-.01.4s.005.271.01.4h.8a.4.4 0 0 0 .4-.4z",
    transform: "translate(-5.95 -14.876)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19613",
    d: "M12.918 32.511a.4.4 0 0 0-.5-.286l-.774.208c.06.264.127.526.207.783l.777-.209a.4.4 0 0 0 .29-.496z",
    transform: "translate(-6.336 -18.572)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19615",
    d: "M15.248 38.2a.4.4 0 0 0-.554-.148l-.695.4q.19.359.4.7l.693-.4a.4.4 0 0 0 .15-.553z",
    transform: "translate(-7.736 -22.016)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19617",
    d: "M19.062 43.09a.4.4 0 0 0-.573 0l-.567.567q.275.3.573.573l.567-.567a.4.4 0 0 0 0-.573z",
    transform: "translate(-10.069 -24.975)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19619",
    d: "M24.1 46.838a.4.4 0 0 0-.553.149l-.4.695c.228.144.462.28.7.4l.4-.695a.4.4 0 0 0-.148-.554z",
    transform: "translate(-13.177 -27.243)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19621",
    d: "M30.013 49.2a.4.4 0 0 0-.5.286l-.209.777c.257.081.519.147.783.207l.208-.774a.4.4 0 0 0-.282-.496z",
    transform: "translate(-16.844 -28.67)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19624",
    d: "M22.063 21.139a10.549 10.549 0 0 0-.252-1.927l-.548-.079.341-.7a10.436 10.436 0 0 0-.746-1.795l-.4-.355v-.346a10.582 10.582 0 0 0-1.183-1.541l-.437-.137-.137-.435a10.582 10.582 0 0 0-1.541-1.185h-.346l-.355-.4a10.436 10.436 0 0 0-1.795-.746l-.685.341-.1-.548a10.549 10.549 0 0 0-1.927-.252l-.4.395-.4-.395a10.549 10.549 0 0 0-1.927.252l-.1.548-.685-.341a10.436 10.436 0 0 0-1.795.746l-.355.4h-.357a10.582 10.582 0 0 0-1.541 1.183l-.137.437-.435.137a10.582 10.582 0 0 0-1.185 1.541v.346l-.4.355a10.436 10.436 0 0 0-.746 1.795l.341.7-.548.079a10.549 10.549 0 0 0-.252 1.927l.395.4-.395.4a10.549 10.549 0 0 0 .252 1.927l.548.079-.341.7a10.436 10.436 0 0 0 .746 1.795l.4.355v.346A10.582 10.582 0 0 0 3.818 28.7l.437.137.137.435a10.582 10.582 0 0 0 1.541 1.184l.751-.4-.05.81a10.436 10.436 0 0 0 1.795.746l.685-.341.1.548a10.549 10.549 0 0 0 1.927.252l.4-.395.4.395a10.549 10.549 0 0 0 1.927-.252l.1-.548.685.341a10.436 10.436 0 0 0 1.795-.746l.355-.4h.346A10.582 10.582 0 0 0 18.7 29.27l.137-.437.435-.137a10.582 10.582 0 0 0 1.185-1.541v-.346l.4-.355a10.436 10.436 0 0 0 .746-1.795l-.341-.685.548-.1a10.549 10.549 0 0 0 .252-1.927l-.395-.4z",
    transform: "translate(-.015 -5.965)",
    style: {
      fill: "#ffc864"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 894",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(3.554 7.554)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19625",
    d: "M7.81 25.909a8.087 8.087 0 0 1 13.4-6.11A8.089 8.089 0 1 0 9.8 31.209a8.059 8.059 0 0 1-1.989-5.3z",
    transform: "translate(-3.57 -9.52)",
    style: {
      fill: "#ff9c28"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 24526"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19626",
    d: "M26.4 12.215a.4.4 0 0 0 .4-.4v-.8c-.134 0-.269-.01-.4-.01s-.271.005-.4.01v.8a.4.4 0 0 0 .4.4z",
    transform: "translate(-14.876 -5.95)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19627",
    d: "M26.4 60a.4.4 0 0 0-.4.4v.8c.134 0 .269.01.4.01s.271-.005.4-.01v-.8a.4.4 0 0 0-.4-.4z",
    transform: "translate(-14.876 -35.107)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19628",
    d: "M20.013 12.918a.4.4 0 0 0 .286-.5l-.208-.774c-.264.06-.526.127-.783.207l.209.777a.4.4 0 0 0 .496.29z",
    transform: "translate(-10.894 -6.336)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19629",
    d: "M32.511 59.2a.4.4 0 0 0-.286.5l.208.774c.264-.06.526-.127.783-.207l-.209-.777a.4.4 0 0 0-.496-.29z",
    transform: "translate(-18.572 -34.62)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19630",
    d: "M14.1 15.248a.4.4 0 0 0 .148-.554l-.4-.695q-.359.19-.7.4l.4.693a.4.4 0 0 0 .553.15z",
    transform: "translate(-7.227 -7.735)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19631",
    d: "M38.2 56.839a.4.4 0 0 0-.148.554l.4.695c.239-.126.473-.262.7-.4l-.4-.693a.4.4 0 0 0-.553-.15z",
    transform: "translate(-22.016 -33.194)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19632",
    d: "M9.062 19.062a.4.4 0 0 0 0-.573l-.567-.567q-.3.275-.573.573l.567.567a.4.4 0 0 0 .573 0z",
    transform: "translate(-4.119 -10.069)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19633",
    d: "M43.09 53.09a.4.4 0 0 0 0 .573l.567.567q.3-.275.573-.573l-.567-.567a.4.4 0 0 0-.573 0z",
    transform: "translate(-24.975 -30.925)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19634",
    d: "M5.248 24.1a.4.4 0 0 0-.149-.553l-.695-.4q-.216.342-.4.7l.695.4a.4.4 0 0 0 .554-.148z",
    transform: "translate(-1.785 -13.177)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19635",
    d: "M46.838 48.2a.4.4 0 0 0 .149.553l.695.4c.144-.228.28-.462.4-.7l-.695-.4a.4.4 0 0 0-.554.148z",
    transform: "translate(-27.243 -27.966)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19636",
    d: "M2.918 30.013a.4.4 0 0 0-.286-.5l-.777-.209a9.901 9.901 0 0 0-.207.783l.774.208a.4.4 0 0 0 .5-.286z",
    transform: "translate(-.386 -16.844)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19637",
    d: "M49.2 42.511a.4.4 0 0 0 .286.5l.777.209c.081-.257.147-.519.207-.783l-.774-.208a.4.4 0 0 0-.496.282z",
    transform: "translate(-28.67 -24.522)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19638",
    d: "M2.215 36.4a.4.4 0 0 0-.4-.4h-.8c0 .134-.01.269-.01.4s.005.271.01.4h.8a.4.4 0 0 0 .4-.4z",
    transform: "translate(0 -20.826)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19639",
    d: "M50 36.4a.4.4 0 0 0 .4.4h.8c0-.134.01-.269.01-.4s-.005-.271-.01-.4h-.8a.4.4 0 0 0-.4.4z",
    transform: "translate(-29.157 -20.826)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19640",
    d: "M2.918 42.511a.4.4 0 0 0-.5-.286l-.774.208c.06.264.127.526.207.783l.777-.209a.4.4 0 0 0 .29-.496z",
    transform: "translate(-.386 -24.522)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19641",
    d: "M49.2 30.013a.4.4 0 0 0 .5.286l.774-.208c-.06-.264-.127-.526-.207-.783l-.777.209a.4.4 0 0 0-.29.496z",
    transform: "translate(-28.67 -16.844)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19642",
    d: "M5.248 48.2a.4.4 0 0 0-.554-.148l-.695.4q.19.359.4.7l.693-.4a.4.4 0 0 0 .15-.553z",
    transform: "translate(-1.785 -27.966)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19643",
    d: "M46.839 24.1a.4.4 0 0 0 .554.148l.695-.4a13.236 13.236 0 0 0-.4-.7l-.693.4a.4.4 0 0 0-.15.553z",
    transform: "translate(-27.244 -13.177)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19644",
    d: "M9.062 53.09a.4.4 0 0 0-.573 0l-.567.567q.275.3.573.573l.567-.567a.4.4 0 0 0 0-.573z",
    transform: "translate(-4.119 -30.925)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19645",
    d: "M43.09 19.062a.4.4 0 0 0 .573 0l.567-.567q-.275-.3-.573-.573l-.567.567a.4.4 0 0 0 0 .573z",
    transform: "translate(-24.975 -10.069)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19646",
    d: "M14.1 56.838a.4.4 0 0 0-.553.149l-.4.695c.228.144.462.28.7.4l.4-.694a.4.4 0 0 0-.148-.554z",
    transform: "translate(-7.227 -33.193)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19647",
    d: "M38.2 15.248a.4.4 0 0 0 .553-.149l.4-.695q-.342-.216-.7-.4l-.4.695a.4.4 0 0 0 .148.554z",
    transform: "translate(-22.016 -7.735)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19648",
    d: "M20.013 59.2a.4.4 0 0 0-.5.286l-.209.777c.257.081.519.147.783.207l.208-.774a.4.4 0 0 0-.282-.496z",
    transform: "translate(-10.894 -34.62)",
    style: {
      fill: "#ffaa32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19649",
    d: "M32.511 12.918a.4.4 0 0 0 .5-.286l.209-.777a9.901 9.901 0 0 0-.783-.207l-.208.774a.4.4 0 0 0 .282.496z",
    transform: "translate(-18.572 -6.336)",
    style: {
      fill: "#ffaa32"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19650",
    d: "m20.118 24.792 1.447 2.933 3.236.47-2.341 2.283.553 3.223-2.895-1.522-2.895 1.521.553-3.223-2.342-2.283 3.236-.47z",
    transform: "translate(-8.589 -14.157)",
    style: {
      fill: "#ffc864"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.51bb92d10624cf0e2dcfc1318f6b387d.svg";
export { ForwardRef as ReactComponent };